import React, {useState, useRef, useEffect} from "react";
import {Chart} from 'primereact/chart';
import axios from "axios";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import * as management from "../actions/management";
import * as auth from "../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Tag} from "primereact/tag";
import '../css/DataTableDemo.css';
import {Toast} from "primereact/toast";

const Dashboard = props => {
    const toast = useRef(0);
    const [contentListFav, setContentListFav] = useState([]);
    const [contentListView, setContentListView] = useState([]);
    const [userLog, setUserLog] = useState([]);
    const [contCount, setContCount] = useState(0);
    const [contCountPublis, setContCountPublis] = useState(0);
    const [contCountDraft, setContCountDraft] = useState(0);
    const [contCountArchive, setContCountArchive] = useState(0);
    const [contCountSss, setContCountSss] = useState(0);
    const [contCountCategory, setContCountCategory] = useState(0);
    const [contCountPages, setContCountPages] = useState(0);
    const [contCountNews, setContCountNews] = useState(0);
    const [contCountActivity, setContCountActivity] = useState(0);
    const [contCountNotification, setContCountNotification] = useState(0);
    const [contCountArticle, setContCountArticle] = useState(0);
    const [contCountModule, setContCountModule] = useState(0);
    const [contCountModule2, setContCountModule2] = useState(0);
    const [contCountModule3, setContCountModule3] = useState(0);
    const [contCountModule4, setContCountModule4] = useState(0);
    const [contCountModule5, setContCountModule5] = useState(0);
    const [contCountModule6, setContCountModule6] = useState(0);
    const home_page = !!localStorage.getItem('home_page');
    const user_list = !!localStorage.getItem('user_list');


    const dt = useRef(0);
    useEffect(() => {


        getContentListAll()
        getUserLog()


    }, []); //Buradaki dizi içine yazılan değer, değişince useeffecti çalıştır.


    const getContentListAll = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/dashboard/', {"headers": headers})
            .then(res => {
                if (res.status === 200) {
                    setContentListFav(res.data.count_fav_total)
                    setContentListView(res.data.count_view_total)
                    setContCount(res.data.CmsContent[0].total_content)
                    setContCountPublis(res.data.CmsContent[0].total_content_published)
                    setContCountDraft(res.data.CmsContent[0].total_content_draft)
                    setContCountSss(res.data.CmsContent[0].sss_question_count)
                    setContCountArchive(res.data.CmsContent[0].count_record_archive)
                    setContCountCategory(res.data.CmsContent[0].count_category)
                    setContCountPages(res.data.CmsContent[0].count_pages)
                    setContCountNews(res.data.CmsContent[0].count_content_news)
                    setContCountActivity(res.data.CmsContent[0].count_content_activity)
                    setContCountNotification(res.data.CmsContent[0].count_content_notification)
                    setContCountArticle(res.data.CmsContent[0].count_content_article)
                    setContCountModule(res.data.CmsContent[0].count_module_platform)
                    setContCountModule2(res.data.CmsContent[0].count_module_butunportaller)
                    setContCountModule3(res.data.CmsContent[0].count_module_y3portal)
                    setContCountModule4(res.data.CmsContent[0].count_module_verikovani)
                    setContCountModule5(res.data.CmsContent[0].count_module_degirmen)
                    setContCountModule6(res.data.CmsContent[0].count_module_modelegitim)

                } else if (res.status === 401) {
                    props.loadUser();
                    throw res.data;

                } else if (res.status === 403) {
                    throw res.data;

                }
            })


    }

    const getUserLog = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/user_logs/', {"headers": headers})
            .then(res => {
                if (res.status === 200) {
                    setUserLog(res.data.user_log_list)

                } else if (res.status === 401) {
                    props.loadUser();
                    throw res.data;

                } else if (res.status === 403) {
                    throw res.data;

                }
            })


    }
    const userlog = (rowData) => {
        const uul_actioncode = rowData["uul_actioncode"];
        if (uul_actioncode === "Sisteme Giris") {
            return <div>
                <Tag style={{textAlign: 'center', fontSize: '9px'}}
                     severity="success"
                     value="Sisteme Giriş" rounded/>
            </div>

        } else if (uul_actioncode === "Sistemden Çıkış") {
            return (
                <div>
                    <Tag
                        style={{textAlign: 'center', fontSize: '9px'}}
                        severity="warning"
                        value="Sistemden Çıkış" rounded/>
                </div>
            )
        } else if (uul_actioncode === "Yeni Kayıt") {
            return (
                <div>
                    <Tag
                        style={{textAlign: 'center', fontSize: '9px'}}
                        severity="info"
                        value="Yeni Kayıt" rounded/>
                </div>
            )
        }
    }


    const revenueChart = {
        labels: ['Haber', 'Etkinlik', 'Duyuru', 'Makale/Blog'],
        datasets: [
            {
                data: [contCountNews, contCountActivity, contCountNotification, contCountArticle],
                backgroundColor: ['#64B5F6', '#7986CB', '#4DB6AC', '#64f6ee']
            }
        ]
    };
    const revenueChart2 = {

        labels: ['Platform', 'Tüm Portaller', 'Y3', 'Veri Kovanı', 'Değirmen', 'Model Eğitim Portali'],
        datasets: [
            {
                data: [contCountModule, contCountModule2, contCountModule3, contCountModule4, contCountModule5, contCountModule6],
                backgroundColor: ["#42A5F5",
                    "#7986CB",
                    "#FF6384",
                    "#FFCE56", '#64f6ee', '#4DB6AC']
            }
        ]
    };
    return (
        <div className="layout-dashboard">
            <Toast ref={toast} position="top-right"/>

            <div className="p-grid">
                <div className="p-col-12 p-md-6 p-xl-3" style={{display: home_page ? 'block' : 'none'}}>
                    <div className="card no-gutter widget-overview-box widget-overview-box-1">
                        <span className="overview-icon">
                            <i className="pi pi pi-calendar"/>
                        </span>
                        <span className="overview-title">Tümü</span>
                        <div className="p-grid overview-detail">
                            <div className="p-col-12">
                                <div className="overview-number">{contCount}</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-xl-3" style={{display: home_page ? 'block' : 'none'}}>
                    <div className="card no-gutter widget-overview-box widget-overview-box-2">
                        <span className="overview-icon">
                            <i className="pi pi-desktop"/>
                        </span>
                        <span className="overview-title">Yayında</span>
                        <div className="p-grid overview-detail">
                            <div className="p-col-12">
                                <div className="overview-number">{contCountPublis}</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-xl-3" style={{display: home_page ? 'block' : 'none'}}>
                    <div className="card no-gutter widget-overview-box widget-overview-box-3">
                        <span className="overview-icon">
                            <i className="pi pi-calendar"/>
                        </span>
                        <span className="overview-title">Taslak</span>
                        <div className="p-grid overview-detail">
                            <div className="p-col-12">
                                <div className="overview-number">{contCountDraft}</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-xl-3" style={{display: home_page ? 'block' : 'none'}}>
                    <div className="card no-gutter widget-overview-box widget-overview-box-4">
                        <span className="overview-icon">
                            <i className="pi pi-eye-slash"/>
                        </span>
                        <span className="overview-title">Arşiv</span>
                        <div className="p-grid overview-detail">
                            <div className="p-col-12">
                                <div className="overview-number">{contCountArchive}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-xl-6">
                    <div className="card revenue">
                        <h4>İçerik Tür Dağılımı</h4>
                        <p>Tüm içerikler baz alınarak yapılmıştır</p>
                        <div className="revenue-chart-container" align="center">
                            <Chart type="pie" id="revenue-chart" data={revenueChart}/>
                        </div>
                    </div>
                </div>

                <div className="p-col-12 p-xl-6">
                    <div className="card revenue">
                        <h4>İçerik Modül Dağılımı</h4>
                        <p>Eklenen içeriklerin modüllere göre dağılımı.</p>
                        <div className="revenue-chart-container" align="center">
                            <Chart type="pie" id="revenue-chart" data={revenueChart2}/>
                        </div>
                    </div>
                </div>

                <div className="p-col-12 p-lg-4" style={{display: home_page ? 'block' : 'none'}}>

                    {/*<div className="datatable-responsive-demo">*/}

                    {/*    <div className="card">*/}
                    {/*        <h4>En Çok Favorilenen İçerikler</h4>*/}
                    {/*        <p>En popüler içerikler</p>*/}

                    {/*        <DataTable*/}
                    {/*            ref={dt}*/}
                    {/*            value={contentListFav}*/}
                    {/*            paginator*/}
                    {/*            className="p-datatable-responsive-demo"*/}
                    {/*            rows={5} dataKey="id"*/}
                    {/*            rowHover*/}
                    {/*            emptyMessage="Kayıt bulunamadı"*/}
                    {/*        >*/}


                    {/*            <Column*/}
                    {/*                field={'cont__cont_title'}*/}
                    {/*                style={{textAlign: 'left', fontWeight: 'bold'}}*/}
                    {/*                header="Başlık"*/}


                    {/*            />*/}


                    {/*            <Column field={'count'}*/}
                    {/*                    header="Favorilenme Sayısı"*/}
                    {/*                    sortable*/}

                    {/*                    style={{textAlign: 'center'}}*/}
                    {/*            />*/}

                    {/*        </DataTable>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="card widget-tasks p-mt-3">
                        <h4>Veriler</h4>
                        <p>Portal Verileri</p>
                        <div>
                            <div className="task task-1">
                                <div className="task-name"><span>{contCountPublis} İçerik</span> (yayında)</div>
                                <div className="task-progress">
                                    <div></div>
                                </div>
                            </div>
                            <div className="task task-2">
                                <div className="task-name"><span>{contCountSss} SSS</span> (sıkça sorulan soru)
                                </div>
                                <div className="task-progress">
                                    <div></div>
                                </div>
                            </div>
                            <div className="task task-3">
                                <div className="task-name"><span>{contCountSss} SSS</span> (sıkça sorulan soru
                                    cevapları)
                                </div>
                                <div className="task-progress">
                                    <div></div>
                                </div>
                            </div>
                            <div className="task task-4">
                                <div className="task-name"><span>{contCountCategory} Kategori</span> (içerik türü
                                    alt
                                    kategorisi)
                                </div>
                                <div className="task-progress">
                                    <div></div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="datatable-responsive-demo p-mt-3"
                         style={{display: home_page ? 'block' : 'none'}}

                    >

                        <div className="card">
                            <h4>Kullanıcı Kayıtları</h4>
                            <DataTable
                                ref={dt}
                                value={userLog}
                                scrollable
                                scrollHeight="250px"
                                className="p-datatable-responsive-demo p-datatable-sm"
                                rowHover
                                emptyMessage="Kayıt Bulunamadı"
                            >
                                <Column
                                    field={'pers_name'}
                                    style={{textAlign: 'center', fontWeight: 'bold', fontSize: '10px'}}
                                    header="Adı"
                                    filter
                                />
                                <Column
                                    field={'pers_surname'}
                                    style={{textAlign: 'center', fontWeight: 'bold', fontSize: '10px'}}
                                    header="Soyadı"
                                    filter
                                />

                                <Column field={'uul_actioncode'}
                                        body={userlog}
                                        header="İşlem"
                                        filter
                                        style={{textAlign: 'center', fontSize: '10px'}}
                                />
                                <Column field={'uul_createtime'}
                                        header="Tarih"
                                        sortable
                                        filter
                                        filterHeaderStyle={{width:'10%'}}
                                        style={{textAlign: 'center', fontWeight: 'bold', fontSize: '9px'}}
                                />

                            </DataTable>
                        </div>
                    </div>


                </div>

                <div className="p-col-12 p-lg-8" style={{display: home_page ? 'block' : 'none'}}>


                    <div className="datatable-responsive-demo">

                        <div className="card">
                            <h4>En Çok Okunan İçerikler</h4>
                            <p>En çok görüntülenen içerikler</p>
                            <DataTable
                                ref={dt}
                                value={contentListView}
                                paginator
                                className="p-datatable-responsive-demo"
                                rows={10} dataKey="id"
                                rowHover
                                emptyMessage="Kayıt Bulunamadı"
                            >


                                <Column
                                    field={'cont__cont_title'}
                                    style={{textAlign: 'left', fontWeight: 'bold'}}
                                    header="Başlık"


                                />


                                <Column field={'count'}
                                        header="Görüntülenme Sayısı"
                                        sortable

                                        style={{textAlign: 'center'}}
                                />

                            </DataTable>
                        </div>
                    </div>


                </div>

            </div>

        </div>

    )
        ;
}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard.jsx